module.exports = __webpack_public_path__ + "img/gauge-max.01e416cf.svg";